"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addRole = addRole;
exports.delRole = delRole;
exports.getInfo = getInfo;
exports.getRoleList = getRoleList;
exports.menuAdd = menuAdd;
exports.menuCacheList = menuCacheList;
exports.menuDelete = menuDelete;
exports.menuInfo = menuInfo;
exports.menuListApi = menuListApi;
exports.menuUpdate = menuUpdate;
exports.updateRole = updateRole;
exports.updateRoleStatus = updateRoleStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.A2.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed A2并不是自由软件，未经许可不能去掉A2相关版权
// +----------------------------------------------------------------------
// | Author: A2 Team <admin@A2.com>
// +----------------------------------------------------------------------

/**
 * 新增
 * @param
 */
function addRole(pram) {
  var data = {
    name: pram.name,
    status: pram.status,
    rules: pram.rules,
    items: pram.items
  };
  // data.rules = pram.rules.join(',')
  return (0, _request.default)({
    url: '/admin/system/tenantPackage/save',
    method: 'POST',
    data: data
  });
}

/**
 * 删除
 * @param
 */
function delRole(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/tenantPackage/delete',
    method: 'GET',
    params: data
  });
}

/**
 * 详情
 * @param
 */
function getInfo(pram) {
  return (0, _request.default)({
    url: "/admin/system/tenantPackage/info/".concat(pram),
    method: 'GET'
  });
}

/**
 * 分页列表
 * @param
 */
function getRoleList(pram) {
  var data = {
    createTime: pram.createTime,
    updateTime: pram.updateTime,
    page: pram.page,
    limit: pram.limit,
    name: pram.name,
    rules: pram.rules,
    items: pram.items,
    status: pram.status
  };
  return (0, _request.default)({
    url: '/admin/system/tenantPackage/list',
    method: 'get',
    params: data
  });
}

/**
 * 修改
 * @param
 */
function updateRole(pram) {
  var data = {
    id: pram.id,
    name: pram.name,
    rules: pram.rules,
    items: pram.items,
    status: pram.status
  };
  return (0, _request.default)({
    url: '/admin/system/tenantPackage/update',
    method: 'post',
    params: {
      id: pram.id
    },
    data: data
  });
}

/**
 * 修改身份状态
 * @param
 */
function updateRoleStatus(pram) {
  return (0, _request.default)({
    url: '/admin/system/tenantPackage/updateStatus',
    method: 'get',
    params: {
      id: pram.id,
      status: pram.status
    }
  });
}

/**
 * 缓存菜单
 * @param
 */
function menuCacheList(pram) {
  return (0, _request.default)({
    url: '/admin/system/mallMenu/cache/tree',
    method: 'get'
  });
}
/**
 * 权限规则菜单列表
 * @param pram
 */
function menuListApi(params) {
  var data = {
    menuType: params.menuType,
    //菜单类型:M-目录，C-菜单，A-按钮
    name: params.name //菜单名称
  };
  return (0, _request.default)({
    url: "/admin/system/mallMenu/list",
    method: 'get',
    params: data
  });
}
function menuInfo(id) {
  return (0, _request.default)({
    url: "/admin/system/mallMenu/info/".concat(id),
    method: 'get'
  });
}
/**
 * 权限规则菜单修改
 * @param data
 */
function menuUpdate(data) {
  var systemMenuRequest = data;
  return (0, _request.default)({
    url: "/admin/system/mallMenu/update",
    method: 'post',
    data: systemMenuRequest
  });
}
function menuAdd(data) {
  var systemMenuRequest = data;
  return (0, _request.default)({
    url: "/admin/system/mallMenu/add",
    method: 'post',
    data: systemMenuRequest
  });
}
function menuDelete(id) {
  return (0, _request.default)({
    url: "/admin/system/mallMenu/delete/".concat(id),
    method: 'post'
  });
}